import {
  Box,
  Button,
  Heading,
  HStack,
  Icon,
  useBoolean,
} from "@chakra-ui/react";
import HowItWorksPopup from "components/HowItWorksPopup";
import IncentivesIllustration from "components/IncentivesIllustration";
import IncentivesPopup from "components/IncentivesPopup";
import useTranslate from "hooks/useTranslate";
import { FaGift, FaPlay } from "react-icons/fa";

const IncentivesBanner = () => {
  const translate = useTranslate();
  const [isIncentivesPopupOpen, setIsIncentivesPopupOpen] = useBoolean(false);
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useBoolean(false);

  return (
    <>
      <Box
        w="full"
        px="3"
        py="4"
        bg="primary.500"
        borderRadius="lg"
        color="dark.900"
      >
        <HStack justify="space-between" spacing="0" px="2">
          <Box flex="1">
            <Heading color="dark.900" fontSize="xl">
              {translate("saleIncentives:title")}
            </Heading>

            <HStack mt="2">
              <Button
                colorScheme="dark"
                size="xs"
                leftIcon={<Icon as={FaPlay} w="3.5" h="3.5" />}
                onClick={setIsVideoPopupOpen.on}
              >
                {translate("saleIncentives:video")}
              </Button>
              <Button
                mt="2"
                colorScheme="dark"
                size="xs"
                leftIcon={<Icon as={FaGift} w="3.5" h="3.5" />}
                onClick={setIsIncentivesPopupOpen.on}
              >
                {translate("saleIncentives:details")}
              </Button>
            </HStack>
          </Box>

          <IncentivesIllustration
            width="100%"
            height="auto"
            style={{
              maxWidth: "10rem",
              minWidth: "rem",
              marginRight: "2%",
            }}
          />
        </HStack>
      </Box>

      {isIncentivesPopupOpen && (
        <IncentivesPopup isOpen onClose={setIsIncentivesPopupOpen.off} />
      )}

      <HowItWorksPopup
        isOpen={isVideoPopupOpen}
        onClose={setIsVideoPopupOpen.off}
      />
    </>
  );
};

export default IncentivesBanner;
